import { g as l } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as s, openBlock as r, normalizeClass as n, createElementVNode as a } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSatisfied",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], h = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.5 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM4 4.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5Zm3 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.5-.5ZM3.7 6.6a.5.5 0 0 1 .698.098L4.4 6.7 4 7l.4-.3v-.001.002l.018.02a2.474 2.474 0 0 0 .408.374c.288.21.687.405 1.174.405.487 0 .886-.195 1.175-.404a2.474 2.474 0 0 0 .424-.395l.003-.003A.5.5 0 0 1 8.4 7.3L8 7l.4.3-.001.001-.001.002-.004.005-.01.014c-.01.01-.021.025-.036.042a3.474 3.474 0 0 1-.585.54c-.4.29-1 .596-1.763.596a2.994 2.994 0 0 1-1.763-.596 3.474 3.474 0 0 1-.62-.582l-.01-.014-.005-.005v-.002H3.6L4 7l-.4.3a.5.5 0 0 1 .1-.7Z",
  "clip-rule": "evenodd"
}, null, -1), f = [
  h
], m = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  p
];
function v(e, I, d, S, b, t) {
  return r(), s("svg", {
    "aria-label": d.ariaLabel,
    class: n([t.iconSizeClass, "d-icon d-icon--satisfied"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Satisfied",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, f, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, m)
    ])
  ], 10, _);
}
const M = /* @__PURE__ */ o(c, [["render", v]]);
export {
  M as default
};
//# sourceMappingURL=satisfied.js.map
